export enum TipoConta {
  DINHEIRO = 'DINHEIRO',
  BANCO = 'BANCO',
}
